module.exports = __webpack_public_path__ + "img/744.efa49982.jpg";